let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j9rwP")).then(() => parcelRequire('fk0bX'));